import { Controller } from "stimulus";

// The browser enforces min and max, but its bubble vanishes on its own and the
// operator is left on a focused field with no message. This writes the same
// reason under the control, where it stays.
export default class extends Controller {
  static targets = ["input", "error"];
  static values = { message: String };

  // Fired by constraint validation on submit, and by blur from data-action.
  // `validity`, not checkValidity(): that one fires `invalid` again, which re-enters here.
  validate() {
    if (this.inputTarget.validity.valid) {
      this.clear();
      return;
    }

    this.errorTarget.textContent = this.messageValue;
    this.inputTarget.classList.add("is-invalid");
  }

  clear() {
    this.errorTarget.textContent = "";
    this.inputTarget.classList.remove("is-invalid");
  }
}
